import React from "react";
import {useMediaQuery} from "beautiful-react-hooks";
import { Link } from "react-router-dom";
import Footer from "./Footer";
export default function BuySellLearn () {

    const isSmall = useMediaQuery('(max-width: 768px)')


    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
    canonical.href = `https://sinatether.com/buysell`;
    }

    return(
        <>
             <div className="header animated slideInDown fixed">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="navigation">
                                    <nav className="navbar navbar-expand-lg navbar-light bg-light">

                                        {isSmall ?
                                                                          <img className={'logo-mobile-css'} src={'./main_logo.svg'} alt={'سیناتتر'}/>








                                                :

                                                <img className={'logo-desk-css'} src={'./main_logo.svg'} alt={'سیناتتر'}/>


  






                                    }

                                        <button className={"navbar-toggler"} type="button" data-toggle="collapse"
                                                data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
                                                aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"/>

                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNavDropdown">
                                            <ul className="navbar-nav">


                                            </ul>
                                        </div>

                                        <div className="signin-btn ">
                                            <a href={"/login"} className="btn btn-primary text-white mybold">ورود | ثبت نام</a>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


           <div className={'mid-main  '}>


               <div className={"title pt-4 "}>
                   <h5 className={"pl-3"}>آموزش خریدوفروش در پلتفرم خرید و فروش سیناتـتر</h5>

               </div>
               <hr/>

               <div className={"body pt-3"}>

                   <img className={'w-100 pb-4 pt-3'} src={'https://static.sinatether.com/images/buy.png'} alt={""}/>

                   <span className={"pt-3 pb-3 text-larger"}>
                       1.
                        پس از ثبت نام و احراز هویت در لیست ارزها روی ارز مدنظر کلید کنید
                        و
                  	سپس روی گزینه خرید  و مبلغ یا مقدار مورد نظر را وارد نمایید
                                      </span>



                   <img className={'w-100 pb-4 pt-3'} src={'https://static.sinatether.com/images/buy2.png'} alt={""}/>

                   <span className={"pt-3 pb-3 text-larger"}>
                       2.
                       	و در اخر پس از اطمینان از خرید خود روی گزینه ثبت خرید کلیک کنید.
                   </span>



                   <span className={"pt-3 pb-3 text-larger"}>
                       توجه:
                       <br/>
                       فرایند فروش هم مشابه فرایند خرید است
                   </span>




                    






               </div>

           </div>


           <Footer/>
        </>
    )

}